import { SdkMessageTypes } from '../constants';
import { HostedWebContentSdkService } from '../hosted-web-content-sdk';
import { CallModalities, ICallService, ITelemetryService, StartCallParams } from '../interfaces';
import { ILegacyLinkHandler } from './deep-link-message-handler';
import { BaseMessageHandler } from './base-message-handler';
import { onSdkError } from './messageHandlingUtils';

export class CallMessageHandler extends BaseMessageHandler {
  constructor(
    appSdkHost: HostedWebContentSdkService,
    protected callService?: ICallService,
    telemetryService?: ITelemetryService
  ) {
    super(appSdkHost, telemetryService);
  }

  public initHandlers(): void {
    this.registerHandler(
      SdkMessageTypes.call.startCall,
      (_, startCallParams: StartCallParams) => this.callService!.startCall(startCallParams),
      {
        errorCallback: (error, scenario) => onSdkError(SdkMessageTypes.call.startCall, error, scenario),
      }
    );
  }

  protected validateDependencies(): void {
    if (!this.callService) {
      throw 'No callService provided';
    }
  }
}

export class CallLegacyLinkHandler implements ILegacyLinkHandler<StartCallParams> {
  constructor(private callService?: ICallService) {}
  public tryGetDataFromLink(url: URL): StartCallParams | null {
    if (!this.callService) {
      return null;
    }
    if (url.origin != 'https://teams.microsoft.com' || url.pathname != '/l/call/0/0') {
      return null;
    }
    const users = url.searchParams.get('users')?.split(',');
    const withVideo = url.searchParams.get('withVideo') == 'true' ? true : false;
    const source = url.searchParams.get('source') || undefined;

    if (!users) {
      return null;
    }

    return {
      targets: users,
      requestedModalities: withVideo ? [CallModalities.Audio, CallModalities.Video] : [CallModalities.Audio],
      source,
    };
  }

  public executeData(params: StartCallParams): Promise<void> {
    return this.callService!.startCall(params).then(() => {});
  }
}
